export default __webpack_public_path__ + "static/1.2-32e08509de5cf3d70cb2a3e2afb1fff7.webp";